var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #04be76;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4070",
    "data-name": "Group 4070",
    transform: "translate(5659 8715)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3590",
    "data-name": "Group 3590"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "cls-1",
    d: "M10.238,22a.737.737,0,0,1-.625-.352c-.161-.255-.959-1.6-1.195-2.114l-1.65-.681c-.586.221-2.135.613-2.34.66a.733.733,0,0,1-.682-.2L2.677,18.244a.743.743,0,0,1-.2-.682l.01-.04c.377-1.47.561-2.062.65-2.3l-.681-1.65C1.91,13.32.531,12.5.343,12.377A.734.734,0,0,1,0,11.754V10.243A.735.735,0,0,1,.35,9.62c.255-.161,1.6-.959,2.114-1.195l.681-1.65c-.221-.586-.613-2.135-.66-2.34a.729.729,0,0,1,.2-.682L3.753,2.677a.743.743,0,0,1,.521-.216.734.734,0,0,1,.161.018l.04.01c1.47.377,2.062.561,2.3.65l1.65-.681C8.678,1.91,9.5.531,9.62.343A.734.734,0,0,1,10.243,0h1.514a.732.732,0,0,1,.622.35c.141.223.955,1.586,1.195,2.114l1.65.681c.586-.222,2.161-.619,2.341-.66a.731.731,0,0,1,.681.2l1.076,1.069a.738.738,0,0,1,.2.682c-.106.419-.468,1.824-.66,2.34l.682,1.65c.545.251,1.916,1.069,2.114,1.195a.733.733,0,0,1,.343.623v1.514a.733.733,0,0,1-.352.629c-.223.141-1.586.955-2.114,1.195l-.681,1.65c.222.586.619,2.161.66,2.341a.736.736,0,0,1-.2.681l-1.069,1.069a.739.739,0,0,1-.52.216.73.73,0,0,1-.162-.018c-.419-.106-1.824-.468-2.34-.66l-1.65.682c-.251.545-1.069,1.916-1.195,2.114a.738.738,0,0,1-.623.343H10.238ZM11,6.2h0A4.794,4.794,0,1,0,14.4,7.609,4.8,4.8,0,0,0,11,6.2Z",
    transform: "translate(-5659 -8715)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    className: "cls-1",
    cx: 2.624,
    cy: 2.624,
    r: 2.624,
    transform: "translate(-5650.75 -8706.75)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1142",
    "data-name": "Rectangle 1142",
    className: "cls-2",
    width: 22,
    height: 22,
    transform: "translate(-5659 -8715)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingActive);
export default __webpack_public_path__ + "static/media/setting_active.2863693a995a19dc2834c38bf3d271a0.svg";
export { ForwardRef as ReactComponent };